import React, { Component } from "react";
import { Layout, Popover, Badge } from "antd";
import { Link } from "react-router-dom";
import axios from "util/Api";

import CustomScrollbars from "util/CustomScrollbars";
import languageData from "./languageData";
import { switchLanguage, toggleCollapsedSideNav, setThemeType } from "../../appRedux/actions/Setting";
import { searchGlobalData } from '../../appRedux/actions/Common';
import SearchBox from "../../components/SearchBox";
import UserInfo from "../../components/UserInfo";
import Auxiliary from "util/Auxiliary";

import { NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE, THEME_TYPE_DARK, THEME_TYPE_LITE } from "../../constants/ThemeSetting";
import { connect } from "react-redux";
import './style.css'
import InAppNotification from "../InAppNotification";
// import AppNotification from "../../components/AppNotification";
// import MailNotification from "../../components/MailNotification";
// import NotificationListener from "../InAppNotification/listner";
import NotificationIcon from "../InAppNotification/notification-icon";
const { Header } = Layout;


class Topbar extends Component {

  state = {
    searchText: '',
    isNotificationPopoverOpen: false,
    alertCount: 0
  };

  intervalId = null;

  languageMenu = () => (
    <CustomScrollbars className="gx-popover-lang-scroll">
      <ul className="gx-sub-popover">
        {languageData.map(language =>
          <li className="gx-media gx-pointer" key={JSON.stringify(language)} onClick={(e) =>
            this.props.switchLanguage(language)
          }>
            <i className={`flag flag-24 gx-mr-2 flag-${language.icon}`} />
            <span className="gx-language-text">{language.name}</span>
          </li>
        )}
      </ul>
    </CustomScrollbars>);

  updateSearchChatUser = (evt) => {
    this.setState({
      searchText: evt.target.value,
    });
  };

  componentDidMount() {
    // Initialize count from localStorage if available
    const storedCount = localStorage.getItem('newAlertsCount')
    if (storedCount !== null) {
      this.setState({ alertCount: parseInt(storedCount, 10) || 0 })
    }

    // Fetch alert count and set up interval
    this.fetchAlertCount()
    this.setupInterval()
    this.setupStorageListener()
  }

  componentWillUnmount() {
    // Clean up interval
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
    // Remove storage event listener
    if (this.handleStorageChange) {
      window.removeEventListener('storage', this.handleStorageChange)
    }
    // Remove custom event listener
    if (this.handleCustomEvent) {
      window.removeEventListener('newAlertsCountUpdated', this.handleCustomEvent)
    }
  }

  fetchAlertCount = async () => {
    try {
      const response = await axios.get('/alerts/new-alerts-count-by-observer')
      let count = 0
      if (response && response.data) {
        // Handle different response formats
        if (typeof response.data === 'number') {
          count = response.data
        } else if (response.data.count !== undefined) {
          count = response.data.count
        } else if (response.data.data !== undefined) {
          count = typeof response.data.data === 'number' ? response.data.data : response.data.data.count || 0
        }
      }

      // Store in localStorage
      localStorage.setItem('newAlertsCount', count.toString())

      // Update state
      this.setState({ alertCount: count })
    } catch (error) {
      console.error('Error fetching alert count:', error)
      // If API fails, try to get from localStorage
      const storedCount = localStorage.getItem('newAlertsCount')
      if (storedCount !== null) {
        this.setState({ alertCount: parseInt(storedCount, 10) || 0 })
      }
    }
  }

  setupInterval = () => {
    // Check localStorage every 5 minutes (300000 ms)
    this.intervalId = setInterval(() => {
      const storedCount = localStorage.getItem('newAlertsCount')
      if (storedCount !== null) {
        this.setState({ alertCount: parseInt(storedCount, 10) || 0 })
      }
    }, 5 * 60 * 1000) // 5 minutes
  }

  setupStorageListener = () => {
    // Listen for storage changes (when AlertInbox updates the count from another tab)
    this.handleStorageChange = (e) => {
      if (e.key === 'newAlertsCount') {
        const newCount = parseInt(e.newValue, 10) || 0
        this.setState({ alertCount: newCount })
      }
    }
    window.addEventListener('storage', this.handleStorageChange)

    // Also listen for custom events (for same-tab updates)
    this.handleCustomEvent = (e) => {
      if (e.detail && e.detail.count !== undefined) {
        this.setState({ alertCount: e.detail.count })
      }
    }
    window.addEventListener('newAlertsCountUpdated', this.handleCustomEvent)
  }

  handleThemeToggle = (checked) => {
    const nextTheme = checked ? THEME_TYPE_DARK : THEME_TYPE_LITE;
    try {
      localStorage.setItem('themeType', nextTheme);
    } catch (error) {
      console.warn('Unable to store theme preference', error);
    }
    if (checked) {
      document.body.classList.add('dark-theme');
    } else {
      document.body.classList.remove('dark-theme');
    }
    this.props.setThemeType(nextTheme);
  }


  render() {
    const { width, navCollapsed, navStyle, authUser, themeType } = this.props;
    const { isNotificationPopoverOpen } = this.state
    const isDarkMode = themeType === THEME_TYPE_DARK;
    // console.log('authUser', authUser);
    const { isPushEnabled = false } = authUser && authUser.organisation || {};
    // console.log('isPushEnabled', isPushEnabled);
    return (
      <Auxiliary>
        {/* <InAppNotification authUser={this.props.authUser} /> */}
        <Header className={`hidePrint ${process.env.REACT_APP_ENVIRONMENT !== 'production' ? 'gx-header-non-production' : ''}`}>
          {navStyle === NAV_STYLE_DRAWER || ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE) ?
            <div className="gx-linebar gx-mr-3">
              <i className="gx-icon-btn icon icon-menu"
                onClick={() => {
                  this.props.toggleCollapsedSideNav(!navCollapsed);
                }}
              />
            </div> : null}
          <Link to="/" className="gx-d-block gx-d-lg-none gx-pointer">&nbsp;</Link>
          {/* DEMO-APP */}

          {/*}*/}
          {/*{*/}
          {/*moment().format('DD-MM-YYYY hh:mm:ss A Z z')*/}
          {/*}*/}
          {/*search box hide start */}
          {width >= TAB_SIZE ?
            <div className="global-search-wrapper" style={{ width: '50%' }}>
              <SearchBox styleName="gx-d-none gx-d-lg-block gx-lt-icon-search-bar-lg"
                placeholder="Search in app..."
                onChange={this.props.searchGlobalData.bind(this)}
                data={this.props.searchData}
                authUser={this.props.authUser}
                width={this.props.width}
                loading={this.props.globalSearchLoading} /></div> : null}
          {/*search box hide end */}

          <ul className="gx-header-notifications gx-ml-auto">
            <li className="gx-notify gx-theme-toggle">
              <button
                type="button"
                className={`gx-daynight-switch ${isDarkMode ? 'is-dark' : 'is-light'}`}
                onClick={() => this.handleThemeToggle(!isDarkMode)}
                aria-pressed={isDarkMode}
                aria-label={isDarkMode ? 'Switch to light theme' : 'Switch to dark theme'}
                title={isDarkMode ? 'Light' : 'Dark'}
              >
                <span className="gx-daynight-star gx-daynight-star1" />
                <span className="gx-daynight-star gx-daynight-star2" />
                <span className="gx-daynight-star gx-daynight-star3" />
                <span className="gx-daynight-thumb">
                  <svg className="gx-daynight-icon gx-daynight-icon-sun" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
                    <line x1="12" y1="2" x2="12" y2="5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="12" y1="19" x2="12" y2="22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="2" y1="12" x2="5" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="19" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="4.9" y1="4.9" x2="7.1" y2="7.1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="16.9" y1="16.9" x2="19.1" y2="19.1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="4.9" y1="19.1" x2="7.1" y2="16.9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <line x1="16.9" y1="7.1" x2="19.1" y2="4.9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                  <svg className="gx-daynight-icon gx-daynight-icon-moon" viewBox="0 0 24 24" fill="none">
                    <path d="M20 15.3A8 8 0 1 1 8.7 4 6.5 6.5 0 1 0 20 15.3Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                  </svg>
                </span>
              </button>
            </li>
            {/* search box hide start */}
            <li className="gx-notify gx-notify-search gx-d-inline-block gx-d-lg-none">
              <Popover style={{ width: '90%', left: '0px' }} overlayClassName="gx-popover-horizantal"
                placement="bottomRight" content={
                  <SearchBox styleName="gx-d-none gx-d-lg-block gx-lt-icon-search-bar-lg"
                    placeholder="Search in app..."
                    onChange={this.props.searchGlobalData.bind(this)}
                    data={this.props.searchData}
                    authUser={this.props.authUser}
                    width={this.props.width}
                    loading={this.props.globalSearchLoading}
                  />
                } trigger="click">
                <span className="gx-topbar-icon gx-pointer">
                  <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="11" cy="11" r="6.5" stroke="currentColor" strokeWidth="2" />
                    <line x1="20" y1="20" x2="15.8" y2="15.8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </span>
              </Popover>
            </li>
            {/* search box hide end */}


            <Auxiliary>
              {isPushEnabled && (
                <>
                  {/* bell notification disabled */}
                  {/* <NotificationListener authUser={this.props.authUser} /> */}

                  <li className="gx-notify">
                    <Popover
                      overlayClassName="gx-popover-horizantal"
                      placement="bottomRight"
                      visible={isNotificationPopoverOpen}
                      content={
                        <InAppNotification
                          authUser={this.props.authUser}
                          isOpen={isNotificationPopoverOpen}
                          onClose={() => this.setState({ isNotificationPopoverOpen: false })}
                        />
                      }
                      trigger="click"
                      onVisibleChange={(visible) => {
                        this.setState({ isNotificationPopoverOpen: visible })
                        if (visible) {
                          localStorage.setItem('hasNewNotifications', 'false')
                          // Trigger notification reload
                          const event = new Event('storage')
                          event.key = 'notifications'
                          window.dispatchEvent(event)
                        }
                      }}
                    >
                      <NotificationIcon onClick={() => {
                        console.log('clicked')
                      }} />
                    </Popover>
                  </li>
                </>
              )}

              <li className="gx-msg">
                <Link to="/alert" className="gx-pointer gx-d-block">
                  <Badge
                    count={this.state.alertCount}
                    overflowCount={999}
                    style={{
                      fontSize: '8px',
                      lineHeight: '12px',
                      height: '14px',
                      minWidth: '14px',
                      padding: '0 2px'
                    }}
                  >
                    <span className="gx-topbar-icon gx-icon-alert">
                      <svg viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="2" />
                        <path d="M3 7l9 6 9-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </Badge>
                </Link>
              </li>
              {/* <li className="gx-msg">
                <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight"
                  content={<MailNotification />} trigger="click">
                  <span className="gx-pointer gx-status-pos gx-d-block">
                    <i className="icon icon-chat-new" />
                  </span>
                </Popover>
              </li> */}
              <li className="gx-user-nav"><UserInfo /></li>
            </Auxiliary>
          </ul>
        </Header>
      </Auxiliary>
    );
  }
}

const mapStateToProps = ({ settings, auth, commonData }) => {
  const { locale, navStyle, navCollapsed, width, themeType } = settings;
  return {
    locale,
    navStyle,
    navCollapsed,
    width,
    themeType,
    authUser: auth.authUser,
    globalSearchLoading: commonData.globalSearchLoading,
    searchData: commonData.globalSearchData
  }
};


export default connect(mapStateToProps, { searchGlobalData, toggleCollapsedSideNav, switchLanguage, setThemeType })(Topbar);
